import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import styled from "styled-components";

interface ContainerProps {
    isPH?: boolean;
}

export const Container = styled.div<ContainerProps>(({ theme, isPH }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: isPH
        ? `${theme.spacing.large} ${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.medium}`
        : `40px ${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.medium}`,
    borderRadius: theme.cornerRadius.large,
    background: theme.colors[theme.colorMode].background_Primary,
    minWidth: "260px",
    position: "relative",
}));

const SUBTITLE_MARGIN_TOP = "28px";

interface IconProps {
    isPH?: boolean;
}

export const Icon = styled.div<IconProps>(({ isPH }) =>
    isPH
        ? {
              width: "135px",
              display: "block",
              margin: "0 auto",
          }
        : {
              position: "absolute",
              top: "0",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "48px",
          },
);

export const CloseIcon = styled.div({
    position: "fixed",
    top: "12px",
    right: "12px",
});

export const Title = styled(Text)(({ theme }) => ({
    color: theme.colors[theme.colorMode].text_Low_Emphasis,
    textAlign: "center",
    alignSelf: "center",
}));

export const Description = styled(Text)(({ theme }) => ({
    color: theme.colors[theme.colorMode].text_Low_Emphasis,
    textAlign: "center",
    alignSelf: "center",
    marginTop: theme.spacing.xSmall,
}));

interface SubtitleProps {
    noMarginTop?: boolean;
}

export const Subtitle = styled.div<SubtitleProps>(({ theme, noMarginTop }) => ({
    fontSize: "24px",
    lineHeight: "28px",
    fontWeight: 800,
    letterSpacing: "-0.4px",
    textAlign: "center",
    color: theme.colors[theme.colorMode].text_Highest_Emphasis,
    marginTop: noMarginTop ? "0" : SUBTITLE_MARGIN_TOP,
}));

export const SecondarySavingsSubtitle = styled.div(({ theme }) => ({
    fontSize: "24px",
    lineHeight: "28px",
    fontWeight: 800,
    letterSpacing: "-0.4px",
    textAlign: "center",
    color: theme.colors[theme.colorMode].text_Highest_Emphasis,
}));

export const SecondaryDiscount = styled.div(({ theme }) => ({
    fontSize: "18px",
    lineHeight: "24px",
    letterSpacing: "-0.3px",
    fontWeight: 600,
    textAlign: "center",
    marginTop: theme.spacing.xxSmall,
    color: theme.colors[theme.colorMode].text_Med_Emphasis,
}));

export const CTA = styled.button(({ theme }) => ({
    fontSize: "18px",
    letterSpacing: "-0.3px",
    fontWeight: 600,
    marginTop: theme.spacing.xLarge,
    textTransform: "uppercase",
    background: "transparent",
    width: "100%",
    height: "48px",
    color: theme.colors[theme.colorMode].primary,
    border: "none",
    cursor: "pointer",
}));

export const PlusIcon = styled.span(() => ({
    fontSize: "13px",
    lineHeight: "16px",
    fontWeight: 200,
    letterSpacing: "-0.3px",
    display: "flex",
    justifyContent: "center",
    marginTop: "8px",
    marginBottom: "8px",
}));

export const ImageInsertedInsidePrimaryText = styled.div(() => ({
    display: "inline-block",
    verticalAlign: "middle",
    minWidth: "28px",
    height: "28px",
}));

export const ImageInsertedInsidePrimaryTextIcon = styled.img(() => ({
    height: "16px",
}));
